module.exports = __webpack_public_path__ + "static/media/doctors.a1597d40.png";